import * as React from 'react';
import {useState} from 'react';
import {Button} from '@flexe/ui-components';

import CreateBarcodesTab from './CreateBarcodesTab';
import PrintLPNsTab from './PrintLPNsTab';

interface PrintStationProps {
  defaultBarcodes: string;
  printCssUrl: string;
}

const PrintStation: React.FC<PrintStationProps> = (props) => {
  const [selectedTab, setSelectedTab] = useState<'createBarcodes' | 'printLPNs'>('createBarcodes');

  return (
    <div>
      <div className={'title-header'}>
        <h2>
          <b>Warehouse Tools</b>
        </h2>
      </div>
      <div className="create-barcodes-index">
        <h3>
          <b>Print Station</b>
        </h3>
        <div className="tab-container" style={{display: 'flex', gap: '30px', marginBottom: '20px'}}>
          <Button
            testid="create-barcodes-button"
            onPress={() => setSelectedTab('createBarcodes')}
            visualType={selectedTab === 'createBarcodes' ? 'primary' : 'secondary'}
          >
            Create Barcodes
          </Button>
          <Button
            testid="print-lpns-button"
            onPress={() => setSelectedTab('printLPNs')}
            visualType={selectedTab === 'printLPNs' ? 'primary' : 'secondary'}
          >
            Print LPNs
          </Button>
        </div>

        {selectedTab === 'createBarcodes' && (
          <CreateBarcodesTab defaultBarcodes={props.defaultBarcodes} printCssUrl={props.printCssUrl} />
        )}

        {selectedTab === 'printLPNs' && <PrintLPNsTab />}
      </div>
    </div>
  );
};

export default PrintStation;
